var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyAreas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.6621,
    r: 36,
    fill: "#94BE43"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 17.57,
    r: 4.5,
    transform: "rotate(45 36 17.57)",
    stroke: "white",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.0919,
    cy: 36.6608,
    r: 4.5,
    transform: "rotate(45 55.0919 36.6608)",
    stroke: "white",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9081,
    cy: 36.6608,
    r: 4.5,
    transform: "rotate(45 16.9081 36.6608)",
    stroke: "white",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 55.7536,
    r: 4.5,
    transform: "rotate(45 36 55.7536)",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.818 20.752L20.0901 33.4799",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.182 52.5717L51.91 39.8438",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.09 39.8438L32.818 52.5717",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.182 20.752L51.9099 33.4799",
    stroke: "white",
    strokeWidth: 3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAreas);
export default __webpack_public_path__ + "static/media/EmptyAreas.2c243b2039da64052ee94c57cc29b30b.svg";
export { ForwardRef as ReactComponent };